/** Display names for stored values. */

export const ROLE_LABELS = {
  gm: 'GM',
  player: 'Player',
};

export const WORLD_PACKS = {
  'shanghai-1842-1949': { name: 'Shanghai 1842–1949', mapId: 'main' },
};
